import { easings, useSpring } from '@react-spring/web';

import { range } from '@sorare/core/src/lib/arrays';

const getSpringSteps = (count: number) => {
  const cardRevealConfig = {
    config: {
      duration: 2000,
      easing: easings.linear,
    },
  };

  return range(count).map(i => ({
    yOffset: -100 * (i + 1),
    ...cardRevealConfig,
    ...(i === 0 ? { delay: 0 } : {}),
  }));
};

type Props = {
  count: number;
};
export const useBackgroundY = ({ count }: Props) => {
  const [{ yOffset }] = useSpring(
    () => ({
      from: {
        yOffset: 0,
      },
      to: [
        ...getSpringSteps(count),
        {
          yOffset: -1500,
          config: {
            duration: 30000,
            easing: easings.linear,
          },
        },
      ],
    }),
    []
  );

  return yOffset;
};
